import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "project-context-header" }
const _hoisted_2 = { class: "project-title" }
const _hoisted_3 = { class: "project-title-link" }
const _hoisted_4 = { class: "plan-row" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = { class: "plan-trigger-content" }
const _hoisted_7 = { class: "plan-name" }
const _hoisted_8 = { class: "dropdown-menu plan-dropdown" }
const _hoisted_9 = {
  key: 0,
  class: "dropdown-item text-muted loading"
}
const _hoisted_10 = { class: "plan-list" }
const _hoisted_11 = { class: "plan-item-left" }
const _hoisted_12 = { class: "plan-item-name" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-success"
}

import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { ProjectPlanListItemReadModel, ProjectPlanListReadModel } from '@Quest/ProjectPlans/readmodels'
    import { useProjectRevenuesQueryV1, useProjectPlanListQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectContextHeader',
  props: {
    projectName: {},
    planId: {},
    planName: {},
    activePlanId: {}
  },
  setup(__props: any) {

    const props = __props

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId))
    const tchProjectId = computed(() => Number(route.params.tchProjectId))
    const projectId = computed(() => String(route.params.projectId))

    const { runProjectPlanListQueryV1,
        modelProjectPlanListQueryV1,
        running: isLoadingPlans
    } = useProjectPlanListQueryV1(workspaceId, tchProjectId, projectId)

    const plans = computed<ProjectPlanListItemReadModel[] | null>(() => (modelProjectPlanListQueryV1.value as ProjectPlanListReadModel)?.Items ?? null)


    function buildRoute(planId: string)
    {
        return {
            name: route.name!,
            params: {
                ...route.params,
                planId
            },
            query: route.query
        }
    }

    function onOpen()
    {
        if (plans.value == null && isLoadingPlans.value === false)
        {
            runProjectPlanListQueryV1()
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Project name "),
    _createElementVNode("h1", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.projectName) + " ", 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-external-link-alt project-title-icon" }, null, -1 /* CACHED */))
      ])), [
        [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${workspaceId.value}/${tchProjectId.value}/${projectId.value}`]
      ])
    ]),
    _createCommentVNode(" Plan selector "),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "plan-trigger",
          onClick: onOpen,
          "data-toggle": "dropdown"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.planName), 1 /* TEXT */),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", __props.planId === __props.activePlanId ? 'badge-success' : 'badge-secondary'])
            }, _toDisplayString(__props.planId === __props.activePlanId ? 'Active' : 'Inactive'), 3 /* TEXT, CLASS */)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-chevron-down dropdown-icon" }, null, -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createCommentVNode(" Loading "),
          (_unref(isLoadingPlans))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1 /* CACHED */),
                _createTextVNode(" Loading... ", -1 /* CACHED */)
              ]))]))
            : (plans.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createCommentVNode(" Loaded "),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, (plan) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: plan.Id,
                        class: _normalizeClass(["dropdown-item plan-item", { 'active-plan': plan.Id === __props.planId }]),
                        to: buildRoute(plan.Id)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(plan.Name), 1 /* TEXT */)
                          ]),
                          (plan.Id === __props.activePlanId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Active "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "to"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dropdown-divider m-0" }, null, -1 /* CACHED */)),
                  _createVNode(_component_router_link, {
                    class: "dropdown-item manage-link",
                    to: { 
                                    name: 'q-project-versions-path', 
                                    params: {
                                        workspaceId: workspaceId.value,
                                        tchProjectId: tchProjectId.value,
                                        projectId: projectId.value
                                    },
                                    query: _unref(route).query }
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "fa fa-cog mr-2" }, null, -1 /* CACHED */),
                      _createTextVNode(" Manage business cases ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}
}

})